var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("app-divider", {
        attrs: {
          label: "Documentos",
          showBorder: true,
          addMarginTop: _vm.addMarginTop
        }
      }),
      _c(
        "el-table",
        { attrs: { data: _vm.documentos } },
        [
          _c("el-table-column", {
            attrs: {
              label: "Nome do arquivo:",
              formatter: _vm.getName,
              "min-width": "280"
            }
          }),
          _c("el-table-column", {
            attrs: {
              label: "Tipo de documento",
              formatter: _vm.getTipoDocumento,
              "min-width": "250"
            }
          }),
          _c("el-table-column", {
            attrs: { label: "Ações", prop: "quantidadeUPFPA", width: "80" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("app-action-button", {
                      attrs: {
                        icone: "download",
                        text: "Download",
                        fontSize: "18",
                        posicaoTooltip: "left"
                      },
                      on: {
                        click: function($event) {
                          return _vm.getDownload(scope.row)
                        }
                      }
                    })
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-40193e7e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40193e7e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/cadastros/para/retificacao/components/resumos/AppResumoDocumentos.vue
// module id = null
// module chunks = 